<template>
  <el-row>
    <el-row class="list-dot-tit mr-b30">
      <el-row class="vertical-center-box">
        <el-col :span="12">
          <strong class="list-tit"><span>알람 처리</span></strong>
        </el-col>
        <el-col :span="12" align="right" class="mr-b10">
          <el-button size="mini" type="primary" @click="insertComment">저장</el-button>
          <el-button size="mini" @click="comment = ''">취소</el-button>
        </el-col>
      </el-row>
      <el-input type="textarea" :rows="5" v-model="comment"></el-input>
    </el-row>
    <el-row class="list-dot-tit mr-b30">
      <strong class="list-tit"><span>처리 이력</span></strong>
      <el-table-wrapper :column-default="columnDefault" :data="eventComments" :columns="eventCommentsColumns" :pagination="false"
        :show-custom-header="false" header-align="center" highlight-current-row>
        <template slot-scope="scope" slot="write-datetime-slot">
          {{ getDateToString(scope.row.writeDatetime, 'YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot-scope="scope" slot="delete-slot">
          <span class="c-pointer" @click="deleteComment(scope.row)"><i class="fal fa-times"></i></span>
        </template>
      </el-table-wrapper>
    </el-row>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import LogAPI from '@/api/log/integrated-log';
import { columnDefault } from '@/constants/table';
import msgUtils from '@/utils/message';
import { getDateToString } from '@/utils/date';

export default {
  name: 'WDetailAlramComment',
  props: {
    eventInfo: Object,
  },
  data() {
    return {
      eventSeq: 0,
      columnDefault,
      comment: '',
      writerId: '',
      eventComments: [],
      eventCommentsColumns: [
        {
          label: '처리자',
          prop: 'writerId',
          width: 150,
        },
        {
          label: '처리 내용',
          prop: 'comment',
        },
        {
          label: '처리 일시',
          scopedSlot: 'write-datetime-slot',
          prop: 'writeDatetime',
          width: 200,
        },
        {
          scopedSlot: 'delete-slot',
          width: 40,
        },
      ],
    };
  },
  computed: mapGetters(['userInfo']),
  watch: {
    eventInfo: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!isEmpty(value) && !isNil(value.eventSeq)) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    this.writerId = this.userInfo.managerId;
  },
  methods: {
    getDateToString,
    loadData() {
      const params = {
        params: {
          eventSeq: this.eventInfo.eventSeq,
        },
      };
      LogAPI.getEventComments(params).then((response) => {
        if (response.data.success) {
          this.eventComments = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, '처리 이력', false));
        throw new Error(e);
      });
    },
    insertComment() {
      if (isEmpty(this.comment)) {
        this.$message(msgUtils.getCustomMsgData('알람 처리 항목을 입력해주세요.'));
        return;
      }
      const params = {
        eventSeq: this.eventInfo.eventSeq,
        writerId: this.writerId,
        comment: this.comment,
      };
      LogAPI.insertEventComment(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '코멘트', response.data.success));
          this.loadData();
          this.comment = '';
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '코멘트', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '코멘트', false));
        throw new Error(e);
      });
    },
    deleteComment(comment) {
      this.$confirm(...msgUtils.getBasicConfirmData(msgUtils.action.DELETE)).then(() => {
        LogAPI.deleteEventComment(comment).then((response) => {
          if (response.data.success) {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '코멘트', response.data.success));
            this.loadData();
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '코멘트', response.data.success));
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, '코멘트', false));
          throw new Error(e);
        });
      }).catch(() => {});
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/Event/DetailEventComment.vue